import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Carousel from 'react-elastic-carousel';
import {
  Card, CardHeader, CardDescription,
  CardText, InfoContainer, InfoTextContainer,
  CarouselContainer
} from './style';

import MapIcon from 'react-feather/dist/icons/map-pin';
import MoneyIcon from 'react-feather/dist/icons/dollar-sign';
import ClockIcon from 'react-feather/dist/icons/clock';
import CalendarIcon from 'react-feather/dist/icons/calendar';
import { primary } from '../../App/theme';
import CustomButton from '../../Button';

import { getDesktopMediaQuery } from '../../../utils';
import { useMediaQuery } from 'react-responsive';

const openURL = (url) => {
  window.open(url, "_blank");
}

const CourseCarousel = (props) => {
  const isDesktopOrLaptop = useMediaQuery(getDesktopMediaQuery());

  return (
    <CarouselContainer>
      <Carousel
        showArrows={false}
        itemsToShow={isDesktopOrLaptop ? 3 : 1}
        pagination={isDesktopOrLaptop || props.items.length === 1 ? false : true}>
        {
          props.items.map((item, i) => <ProductItem key={i} item={item} />)
        }
      </Carousel>
    </CarouselContainer>
  )
}

const ProductItem = (props) => {
  return (
    <Card>
      <CardHeader>{props.item.type}</CardHeader>
      <CardDescription>{props.item.title}</CardDescription>
      <InfoContainer>
        <InfoTextContainer>
          <MapIcon color={primary.light} />
          <CardText>{props.item.location}</CardText>
        </InfoTextContainer>
        <InfoTextContainer>
          <MoneyIcon color={primary.light} />
          <CardText>{props.item.price}</CardText>
        </InfoTextContainer>
        <InfoTextContainer>
          <ClockIcon color={primary.light} />
          <CardText>{props.item.time}</CardText>
        </InfoTextContainer>
      </InfoContainer>
      <InfoContainer>
        <InfoTextContainer>
          <CalendarIcon color={primary.light} />
          <CardText>{props.item.date}</CardText>
        </InfoTextContainer>
      </InfoContainer>
      <CustomButton
        style={{ marginTop: '2vh' }}
        title='Inscreva-se'
        onClick={() => openURL(props.item.url)}
      />
    </Card>
  )
}

class Product extends Component {
  render() {
    const { data } = this.props.product;

    return <CourseCarousel items={data} />;
  }
}

const mapStateToProps = ({ product }) => ({ product });

export default compose(
  connect(mapStateToProps, null)
)(Product);